<template>
    <section class="dp-layout">
        <section class="dp-left">
            <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
        </section>

        <section class="dp-right">
            <!--工具条-->
            <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

            <div class="tbl-scroll-host cat-list-host">
                <div class="cat-list" v-loading="listLoading">
                    <div v-if="!listLoading && !(dimensions && dimensions.length)" class="cat-list__empty">
                        <i class="el-icon-folder-opened"></i>
                        <span>暂无评价维度，请点击上方「添加一级类型」</span>
                    </div>
                    <article
                        v-for="l1 in dimensions"
                        :key="l1.Id"
                        class="cat-group"
                        :class="{ 'is-open': isGroupOpen(l1.Id) }"
                    >
                        <div class="cat-group__head" @click="toggleGroup(l1.Id)">
                            <button class="cat-group__fold" type="button" tabindex="-1" :title="isGroupOpen(l1.Id) ? '收起' : '展开'">
                                <i :class="isGroupOpen(l1.Id) ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
                            </button>
                            <div class="cat-group__main">
                                <div class="cat-group__name">
                                    <span class="cat-list-icon">
                                        <img v-if="getListDimensionIcon(l1)" v-oss-src="getListDimensionIcon(l1)" alt=""
                                            @click.stop="openIconPreview(getListDimensionIcon(l1), l1.Name)">
                                        <i v-else class="el-icon-picture-outline"></i>
                                    </span>
                                    <span class="cat-sort">{{ Number(l1.SortOrder) || 0 }}</span>
                                    {{ l1.Name }}
                                </div>
                                <div class="cat-group__meta">
                                    <span class="cat-tag cat-tag--purple"><i class="el-icon-user"></i> {{ getVisibleRoleText(l1) }}</span>
                                    <span v-if="l1.NotifyClassTeacherOnDeduct" class="cat-tag cat-tag--gray"><i class="el-icon-message"></i> 扣分通知班主任</span>
                                    <span v-if="hasScoreAlert(l1)" class="cat-tag cat-tag--gray"><i class="el-icon-warning-outline"></i> 分数红线</span>
                                    <span class="cat-tag cat-tag--gray"><i class="el-icon-folder"></i> {{ (l1.Children && l1.Children.length) || 0 }} 个子类</span>
                                </div>
                            </div>
                            <div class="cat-group__ops" @click.stop>
                                <el-button type="text" size="mini" icon="el-icon-plus" class="cat-btn-add" @click="handleAddSub1(l1)">添加二级</el-button>
                                <el-button type="text" size="mini" icon="el-icon-edit" class="cat-btn-edit" @click="handleEdit(l1)">编辑</el-button>
                                <el-button type="text" size="mini" icon="el-icon-delete" class="cat-btn-danger" @click="handleDel(l1)">删除</el-button>
                            </div>
                        </div>
                        <div v-show="isGroupOpen(l1.Id)" class="cat-group__body">
                            <div
                                v-for="l2 in (l1.Children || [])"
                                :key="l2.Id"
                                class="cat-child"
                            >
                                <div class="cat-child__main">
                                    <span class="cat-list-icon cat-list-icon--small">
                                        <img v-if="getListDimensionIcon(l2, l1)" v-oss-src="getListDimensionIcon(l2, l1)" alt=""
                                            @click.stop="openIconPreview(getListDimensionIcon(l2, l1), l2.Name)">
                                        <i v-else class="el-icon-picture-outline"></i>
                                    </span>
                                    <span class="cat-child__dot"></span>
                                    <span class="cat-sort cat-sort--sm">{{ Number(l2.SortOrder) || 0 }}</span>
                                    <span class="cat-child__name">{{ l2.Name }}</span>
                                    <span class="cat-child__count" :class="{ 'is-empty': !(Number(l2.ItemCount) || 0) }">
                                        <i class="el-icon-star-off"></i>
                                        评价项 {{ Number(l2.ItemCount) || 0 }}
                                    </span>
                                </div>
                                <div class="cat-child__ops">
                                    <el-button type="text" size="mini" icon="el-icon-document" class="cat-btn-subitem" @click="handleItems(l2)">评价项</el-button>
                                    <el-button type="text" size="mini" icon="el-icon-edit" class="cat-btn-edit" @click="handleEdit(l2)">编辑</el-button>
                                    <el-button type="text" size="mini" icon="el-icon-delete" class="cat-btn-danger" @click="handleDel(l2)">删除</el-button>
                                </div>
                            </div>
                            <div v-if="!(l1.Children && l1.Children.length)" class="cat-child--empty">
                                <span>当前分类下暂无二级类型，</span>
                                <span class="empty-add-btn" @click="handleAddSub1(l1)"><i class="el-icon-plus"></i>立即添加二级</span>
                            </div>
                        </div>
                    </article>
                </div>
            </div>

            <!--分页-->
            <div class="pagination-container">
                <el-pagination layout="total,prev, pager, next" @size-change="handleSizeChange"
                    @current-change="handleCurrentChange" :current-page="page" :page-size="PageSize"
                    :total="total"></el-pagination>
            </div>

            <!--编辑界面-->
            <el-dialog :title="dialogTitle" :visible.sync="editFormVisible" width="640px" custom-class="dim-edit-dialog" :close-on-click-modal="false">
                <el-form :model="editForm" label-width="88px" :rules="editFormRules" ref="editForm" class="dim-edit-form">
                    <!-- 去除所属部门选择，直接关联页面统一选中的学校 ID -->

                    <el-tabs v-model="dimensionSettingsTab" class="dimension-settings-tabs">
                        <el-tab-pane label="基础信息" name="basic">

                    <el-form-item label="父级维度" v-if="editForm.Level === 2 && editForm.DepartmentId" prop="ParentId">
                        <el-select v-model="editForm.ParentId" placeholder="请选择父级维度" style="width: 100%;">
                            <el-option v-for="p in parentCategories" :key="p.Id" :label="p.Name"
                                :value="p.Id"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="维度名称" prop="Name">
                        <el-input v-model="editForm.Name" maxlength="500" show-word-limit></el-input>
                    </el-form-item>

                    <el-form-item label="序号" prop="SortOrder">
                        <el-input-number v-model="editForm.SortOrder" :min="0" :precision="0" :step="1" style="width: 100%"></el-input-number>
                        <p class="form-item-hint">数值越小越靠前，手机端按此排序</p>
                    </el-form-item>

                    <el-form-item v-if="editForm.Level === 1 || editForm.Level === 2" label="可见角色">
                        <el-select v-model="editFormRoleIds" multiple filterable
                            :collapse-tags="shouldCollapseEditFormRoleTags"
                            class="role-select-visible"
                            placeholder="不选则按默认规则" style="width: 100%;" :loading="roleOptionsLoading">
                            <el-option v-for="role in enabledRoleOptions" :key="role.Id" :label="role.Name"
                                :value="role.Id"></el-option>
                        </el-select>
                        <p class="form-item-hint" v-if="editForm.Level === 1">未配置时默认全体教职工可见</p>
                        <p class="form-item-hint" v-else>未配置时继承父级维度；可显式选择「全体教职工」覆盖父级限制</p>
                    </el-form-item>

                    <el-form-item label="图标" class="dim-icons">
                        <el-radio-group v-if="editForm.Level === 2" v-model="editForm.IconSource" class="icon-source-group" @change="handleDimensionIconSourceChange">
                            <el-radio label="Parent">继承一级图标</el-radio>
                            <el-radio label="Custom">自定义图标</el-radio>
                        </el-radio-group>
                        <div v-if="editForm.Level === 2 && editForm.IconSource === 'Parent'" class="icon-inherit-preview">
                            <img v-if="getParentIcon()" v-oss-src="getParentIcon()" alt="">
                            <span>跟随一级：{{ getParentName() }}</span>
                        </div>
                        <div v-if="editForm.Level !== 2 || editForm.IconSource === 'Custom'" class="icon-field">
                            <div class="icon-select-row">
                                <div class="icon-current-preview">
                                    <img v-if="editForm.Icon" v-oss-src="editForm.Icon" alt="">
                                    <i v-else class="el-icon-picture-outline"></i>
                                </div>
                                <el-button size="mini" type="primary" plain icon="el-icon-picture"
                                    @click="openIconPicker('Dimension', 'dimension')">选择图标</el-button>
                            </div>
                            <p class="form-item-hint">可选择全局图标或本校自定义图标</p>
                        </div>
                    </el-form-item>

                        </el-tab-pane>
                        <el-tab-pane v-if="editForm.Level === 1" label="通知与预警" name="notice">
                            <el-form-item label="扣分通知">
                                <div class="notice-switch-row">
                                    <span>通知班主任</span>
                                    <el-switch v-model="editForm.NotifyClassTeacherOnDeduct"></el-switch>
                                </div>
                                <p class="form-item-hint">出现扣分时通知该班班主任</p>
                            </el-form-item>
                            <el-form-item label="分数红线" class="notice-metrics-item">
                                <div class="dim-metrics">
                                    <label class="dim-metric">
                                        <span class="dim-metric__name">本周</span>
                                        <el-input-number v-model="editForm.ScoreAlertWeekThreshold" :min="0" :precision="2" :step="1" :controls="false" placeholder="关闭"></el-input-number>
                                        <span class="dim-metric__unit">分</span>
                                    </label>
                                    <label class="dim-metric">
                                        <span class="dim-metric__name">本月</span>
                                        <el-input-number v-model="editForm.ScoreAlertMonthThreshold" :min="0" :precision="2" :step="1" :controls="false" placeholder="关闭"></el-input-number>
                                        <span class="dim-metric__unit">分</span>
                                    </label>
                                    <label class="dim-metric">
                                        <span class="dim-metric__name">学期</span>
                                        <el-input-number v-model="editForm.ScoreAlertSemesterThreshold" :min="0" :precision="2" :step="1" :controls="false" placeholder="关闭"></el-input-number>
                                        <span class="dim-metric__unit">分</span>
                                    </label>
                                </div>
                                <p class="form-item-hint">留空即关闭。学期红线需要已设置当前学期</p>
                            </el-form-item>
                            <el-form-item label="预警通知">
                                <div class="notice-switch-group">
                                    <div class="notice-switch-row">
                                        <span>通知德育处</span>
                                        <el-switch v-model="editForm.ScoreAlertNotifyTeacher"></el-switch>
                                    </div>
                                    <div class="notice-switch-row">
                                        <span>通知家长</span>
                                        <el-switch v-model="editForm.ScoreAlertNotifyParent"></el-switch>
                                    </div>
                                </div>
                            </el-form-item>
                        </el-tab-pane>
                    </el-tabs>

                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="editFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="editSubmit" :loading="editLoading">确 定</el-button>
                </div>
            </el-dialog>

            <!--评价项列表对话框-->
            <el-dialog :title="(currentDimension && currentDimension.Name) ? (currentDimension.Name + ' - 评价项') : '评价项'"
                :visible.sync="itemsDialogVisible" width="60%" :close-on-click-modal="false">
                <!--工具条-->
                <div class="item-toolbar">
                    <el-button type="primary" icon="el-icon-plus" @click="handleAddItem">新增</el-button>
                </div>

                <!--评价项列表-->
                <el-tabs v-model="activeTab" @tab-click="handleTabClick">
                    <el-tab-pane :name="'praise'">
                        <span slot="label">
                            表扬
                            <el-badge :value="praiseTotal" class="tab-badge" v-if="praiseTotal > 0" />
                        </span>
                        <el-table :data="praiseItems" v-loading="itemsLoading" style="width: 100%; margin-top: 20px;">

                            <el-table-column prop="SortOrder" label="序号" width="70" align="center" />

                            <el-table-column prop="Name" label="评价项名称" min-width="140" align="center" show-overflow-tooltip />

                            <el-table-column prop="Icon" label="图标" width="80" align="center">
                                <template slot-scope="scope">
                                    <img v-if="getItemPreviewIcon(scope.row)" v-oss-src="getItemPreviewIcon(scope.row)"
                                        class="dimension-icon">
                                </template>
                            </el-table-column>

                            <el-table-column prop="ItemKind" label="项目分组" width="100" align="center">
                                <template slot-scope="scope">
                                    <el-tag :type="scope.row.ItemKind === 'Praise' ? 'success' : 'danger'" size="small">
                                        {{ scope.row.ItemKind == 'Praise' ? '表扬' : '待改进' }}
                                    </el-tag>
                                </template>
                            </el-table-column>

                            <el-table-column prop="ScoreMode" label="分值模式" width="100" align="center">
                                <template slot-scope="scope">
                                    <el-tag type="info" size="small">
                                        {{ formatScoreModeLabel(scope.row.ScoreMode) }}
                                    </el-tag>
                                </template>
                            </el-table-column>

                            <el-table-column prop="IsPushToParent" label="推送给家长" width="140" align="center">
                                <template slot-scope="scope">
                                    <el-tag :type="scope.row.IsPushToParent ? 'success' : 'info'" size="small">
                                        {{ scope.row.IsPushToParent ? '推送' : '不推送' }}
                                    </el-tag>
                                </template>
                            </el-table-column>

                            <el-table-column prop="ScoreValue" label="分值" width="120" align="center">
                                <template slot-scope="scope">
                                    <span
                                        :class="['score-value', scope.row.ItemKind === 'Praise' ? 'score-add' : 'score-deduct']">
                                        {{ formatItemScoreText(scope.row) }}
                                    </span>
                                </template>
                            </el-table-column>

                            <el-table-column prop="CreateTime" label="创建时间" width="180" align="center">
                            </el-table-column>

                            <el-table-column label="操作" width="200" align="center" fixed="right">
                                <template slot-scope="scope">
                                    <el-button size="mini" type="warning" icon="el-icon-edit"
                                        @click="handleEditItem(scope.row)">
                                        编辑
                                    </el-button>
                                    <el-button size="mini" type="danger" icon="el-icon-delete"
                                        @click="handleDelItem(scope.row)">
                                        删除
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <!-- 分页 -->

                        <div class="pagination-container">
                            <el-pagination layout="total,prev, pager, next" @size-change="handlePraiseSizeChange"
                                @current-change="handlePraiseCurrentChange" :current-page="praisePage"
                                :page-size="praisePageSize" :total="praiseTotal"></el-pagination>
                        </div>

                    </el-tab-pane>
                    <el-tab-pane :name="'improvement'">
                        <span slot="label">
                            待改进
                            <el-badge :value="improvementTotal" class="tab-badge" v-if="improvementTotal > 0" />
                        </span>
                        <el-table :data="improvementItems" v-loading="itemsLoading"
                            style="width: 100%; margin-top: 20px;">

                            <el-table-column prop="SortOrder" label="序号" width="70" align="center" />

                            <el-table-column prop="Name" label="评价项名称" min-width="140" align="center" show-overflow-tooltip />

                            <el-table-column prop="Icon" label="图标" width="80" align="center">
                                <template slot-scope="scope">
                                    <img v-if="getItemPreviewIcon(scope.row)" v-oss-src="getItemPreviewIcon(scope.row)"
                                        class="dimension-icon">
                                </template>
                            </el-table-column>

                            <el-table-column prop="ItemKind" label="项目分组" width="100" align="center">
                                <template slot-scope="scope">
                                    <el-tag :type="scope.row.ItemKind === 'Praise' ? 'success' : 'danger'" size="small">
                                        {{ scope.row.ItemKind == 'Praise' ? '表扬' : '待改进' }}
                                    </el-tag>
                                </template>
                            </el-table-column>

                            <el-table-column prop="ScoreMode" label="分值模式" width="100" align="center">
                                <template slot-scope="scope">
                                    <el-tag type="info" size="small">
                                        {{ formatScoreModeLabel(scope.row.ScoreMode) }}
                                    </el-tag>
                                </template>
                            </el-table-column>

                            <el-table-column prop="IsPushToParent" label="推送给家长" width="140" align="center">
                                <template slot-scope="scope">
                                    <el-tag :type="scope.row.IsPushToParent ? 'success' : 'info'" size="small">
                                        {{ scope.row.IsPushToParent ? '推送' : '不推送' }}
                                    </el-tag>
                                </template>
                            </el-table-column>

                            <el-table-column prop="ScoreValue" label="分值" width="120" align="center">
                                <template slot-scope="scope">
                                    <span
                                        :class="['score-value', scope.row.ItemKind === 'Praise' ? 'score-add' : 'score-deduct']">
                                        {{ formatItemScoreText(scope.row) }}
                                    </span>
                                </template>
                            </el-table-column>

                            <el-table-column prop="CreateTime" label="创建时间" width="180" align="center">
                            </el-table-column>

                            <el-table-column label="操作" width="200" align="center" fixed="right">
                                <template slot-scope="scope">
                                    <el-button size="mini" type="warning" icon="el-icon-edit"
                                        @click="handleEditItem(scope.row)">
                                        编辑
                                    </el-button>
                                    <el-button size="mini" type="danger" icon="el-icon-delete"
                                        @click="handleDelItem(scope.row)">
                                        删除
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <!-- 分页 -->

                        <div class="pagination-container">
                            <el-pagination layout="total,prev, pager, next" @size-change="handleImprovementSizeChange"
                                @current-change="handleImprovementCurrentChange" :current-page="improvementPage"
                                :page-size="improvementPageSize" :total="improvementTotal"></el-pagination>
                        </div>

                    </el-tab-pane>
                </el-tabs>

                <!--项目编辑界面-->
                <el-dialog title="编辑评价项" :visible.sync="editItemFormVisible" width="580px" append-to-body
                    :close-on-click-modal="false">
                    <el-form :model="editItemForm" label-width="120px" :rules="editItemFormRules" ref="editItemForm">
                        <el-form-item label="评价项名称" prop="Name">
                            <el-input v-model="editItemForm.Name" maxlength="500" show-word-limit></el-input>
                        </el-form-item>

                        <el-form-item label="序号" prop="SortOrder">
                            <el-input-number v-model="editItemForm.SortOrder" :min="0" :precision="0" :step="1" style="width: 100%"></el-input-number>
                            <p class="form-item-hint">数值越小越靠前，手机端按此排序</p>
                        </el-form-item>

                        <el-form-item label="项目分组" prop="ItemKind">
                            <el-radio-group v-model="editItemForm.ItemKind">
                                <el-radio label="Praise">表扬</el-radio>
                                <el-radio label="Improvement">待改进</el-radio>
                            </el-radio-group>
                        </el-form-item>

                        <el-form-item label="分值模式" prop="ScoreMode">
                            <el-radio-group v-model="editItemForm.ScoreMode">
                                <el-radio label="Fixed">固定值</el-radio>
                                <el-radio label="Max">最大值</el-radio>
                                <el-radio label="Range">分数范围</el-radio>
                            </el-radio-group>
                        </el-form-item>

                        <el-form-item v-if="editItemForm.ScoreMode === 'Range'" label="最低分" prop="MinScore">
                            <el-input-number v-model="editItemForm.MinScore" :precision="2" :step="0.1" :min="0"
                                :max="editItemForm.ScoreValue || 1000" style="width: 100%">
                            </el-input-number>
                        </el-form-item>

                        <el-form-item :label="editItemForm.ScoreMode === 'Range' ? '最高分' : '分值'" prop="ScoreValue">
                            <el-input-number v-model="editItemForm.ScoreValue" :precision="2" :step="0.1" :min="0"
                                :max="1000" style="width: 100%">
                            </el-input-number>
                        </el-form-item>

                        <el-form-item label="是否推送给家长" prop="IsPushToParent">
                            <el-switch v-model="editItemForm.IsPushToParent" active-text="推送"
                                inactive-text="不推送"></el-switch>
                        </el-form-item>

                        <el-form-item label="图标" class="dim-icons" prop="Icon">
                            <el-radio-group v-model="editItemForm.IconSource" class="icon-source-group"
                                @change="handleItemIconSourceChange(editItemForm)">
                                <el-radio label="Level2">继承二级图标</el-radio>
                                <el-radio label="Level1">继承一级图标</el-radio>
                                <el-radio label="Custom">自定义图标</el-radio>
                            </el-radio-group>
                            <div v-if="editItemForm.IconSource !== 'Custom'" class="icon-inherit-preview">
                                <img v-if="getItemPreviewIcon(editItemForm)" v-oss-src="getItemPreviewIcon(editItemForm)" alt="">
                                <span>{{ getItemInheritLabel(editItemForm) }}</span>
                            </div>
                            <div v-else class="icon-field">
                                <div class="icon-select-row">
                                    <div class="icon-current-preview">
                                        <img v-if="editItemForm.Icon" v-oss-src="editItemForm.Icon" alt="">
                                        <i v-else class="el-icon-picture-outline"></i>
                                    </div>
                                    <el-button size="mini" type="primary" plain icon="el-icon-picture"
                                        @click="openIconPicker('Item', 'editItem')">选择图标</el-button>
                                </div>
                                <p class="form-item-hint">可选择全局图标或本校自定义图标</p>
                            </div>
                        </el-form-item>

                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="editItemFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="editItemSubmit" :loading="editItemLoading">确 定</el-button>
                    </div>
                </el-dialog>

                <!--项目新增界面-->
                <el-dialog title="新增评价项" :visible.sync="addItemFormVisible" width="580px" append-to-body
                    :close-on-click-modal="false">
                    <el-form :model="addItemForm" label-width="120px" :rules="addItemFormRules" ref="addItemForm">
                        <el-form-item label="评价项名称" prop="Name">
                            <el-input v-model="addItemForm.Name" maxlength="500" show-word-limit></el-input>
                        </el-form-item>

                        <el-form-item label="序号" prop="SortOrder">
                            <el-input-number v-model="addItemForm.SortOrder" :min="0" :precision="0" :step="1" style="width: 100%"></el-input-number>
                            <p class="form-item-hint">数值越小越靠前，手机端按此排序</p>
                        </el-form-item>

                        <el-form-item label="项目分组" prop="ItemKind">
                            <el-radio-group v-model="addItemForm.ItemKind">
                                <el-radio label="Praise">表扬</el-radio>
                                <el-radio label="Improvement">待改进</el-radio>
                            </el-radio-group>
                        </el-form-item>

                        <el-form-item label="分值模式" prop="ScoreMode">
                            <el-radio-group v-model="addItemForm.ScoreMode">
                                <el-radio label="Fixed">固定值</el-radio>
                                <el-radio label="Max">最大值</el-radio>
                                <el-radio label="Range">分数范围</el-radio>
                            </el-radio-group>
                        </el-form-item>

                        <el-form-item v-if="addItemForm.ScoreMode === 'Range'" label="最低分" prop="MinScore">
                            <el-input-number v-model="addItemForm.MinScore" :precision="2" :step="0.1" :min="0"
                                :max="addItemForm.ScoreValue || 1000" style="width: 100%">
                            </el-input-number>
                        </el-form-item>

                        <el-form-item :label="addItemForm.ScoreMode === 'Range' ? '最高分' : '分值'" prop="ScoreValue">
                            <el-input-number v-model="addItemForm.ScoreValue" :precision="2" :step="0.1" :min="0"
                                :max="1000" style="width: 100%">
                            </el-input-number>
                        </el-form-item>

                        <el-form-item label="是否推送给家长" prop="IsPushToParent">
                            <el-switch v-model="addItemForm.IsPushToParent" active-text="推送"
                                inactive-text="不推送"></el-switch>
                        </el-form-item>

                        <el-form-item label="图标" class="dim-icons" prop="Icon">
                            <el-radio-group v-model="addItemForm.IconSource" class="icon-source-group"
                                @change="handleItemIconSourceChange(addItemForm)">
                                <el-radio label="Level2">继承二级图标</el-radio>
                                <el-radio label="Level1">继承一级图标</el-radio>
                                <el-radio label="Custom">自定义图标</el-radio>
                            </el-radio-group>
                            <div v-if="addItemForm.IconSource !== 'Custom'" class="icon-inherit-preview">
                                <img v-if="getItemPreviewIcon(addItemForm)" v-oss-src="getItemPreviewIcon(addItemForm)" alt="">
                                <span>{{ getItemInheritLabel(addItemForm) }}</span>
                            </div>
                            <div v-else class="icon-field">
                                <div class="icon-select-row">
                                    <div class="icon-current-preview">
                                        <img v-if="addItemForm.Icon" v-oss-src="addItemForm.Icon" alt="">
                                        <i v-else class="el-icon-picture-outline"></i>
                                    </div>
                                    <el-button size="mini" type="primary" plain icon="el-icon-picture"
                                        @click="openIconPicker('Item', 'addItem')">选择图标</el-button>
                                </div>
                                <p class="form-item-hint">可选择全局图标或本校自定义图标</p>
                            </div>
                        </el-form-item>

                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="addItemFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="addItemSubmit" :loading="addItemLoading">确 定</el-button>
                    </div>
                </el-dialog>
            </el-dialog>

            <el-dialog title="选择图标" :visible.sync="showIconLib" width="620px" append-to-body
                custom-class="icon-library-dialog">
                <div class="icon-library-toolbar">
                    <el-radio-group v-model="iconLibraryTab" size="small" @change="handleIconLibraryTabChange">
                        <el-radio-button label="all">全部图标</el-radio-button>
                        <el-radio-button label="school">本校图标</el-radio-button>
                    </el-radio-group>
                    <el-button size="small" type="primary" plain icon="el-icon-upload2"
                        @click="openIconUpload">上传本校图标</el-button>
                </div>
                <div class="icon-library-section">
                    <div class="icon-library-section__title">图标库 <span>{{ filteredIconList.length }} 个</span></div>
                    <div class="icon-library-grid">
                        <button v-for="icon in filteredIconList" :key="icon.Id || icon.IconUrl"
                            type="button" class="icon-library-item"
                            :class="{ 'is-selected': isPickerIconSelected(icon) }"
                            @click="selectPickerIcon(icon)">
                            <img v-oss-src="icon.IconUrl" :alt="icon.Name || '评价图标'">
                            <span class="icon-library-item__name">{{ icon.Name || '未命名图标' }}</span>
                            <i v-if="isDeptIdEqual(icon.DepartmentId, DepartmentId)"
                                class="el-icon-delete icon-library-item__delete"
                                title="删除本校图标"
                                @click.stop="removeSchoolIcon(icon)"></i>
                        </button>
                    </div>
                    <div v-if="!filteredIconList.length" class="icon-library-empty">
                        <i class="el-icon-picture-outline"></i>
                        <span>暂无本校图标，可上传一个</span>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="showIconLib = false">取消</el-button>
                    <el-button type="primary" :disabled="!pickerSelectedIcon"
                        @click="confirmPickerIcon">确定</el-button>
                </div>
            </el-dialog>

            <el-dialog title="上传本校图标" :visible.sync="iconUploadDialogVisible" width="440px"
                append-to-body custom-class="icon-upload-dialog">
                <div class="icon-upload-panel">
                <el-upload
                    ref="iconUpload"
                    class="icon-upload-area"
                    drag
                    action="#"
                    :auto-upload="false"
                    :limit="1"
                    :show-file-list="false"
                    accept=".png,.jpg,.jpeg,.webp"
                    :on-change="handleIconUploadChange"
                    :on-exceed="handleIconUploadExceed">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将图标拖到此处，或<em>点击选择</em></div>
                    <div class="el-upload__tip">支持 PNG、JPG、JPEG、WEBP，大小不超过 2MB</div>
                </el-upload>
                <div v-if="iconUploadFile" class="icon-upload-file">
                    <i class="el-icon-picture"></i>{{ iconUploadFile.name }}
                </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="iconUploadDialogVisible = false">取消</el-button>
                    <el-button type="primary" :loading="iconUploadLoading"
                        :disabled="!iconUploadFile" @click="uploadIconSubmit">上传并使用</el-button>
                </div>
            </el-dialog>

            <el-dialog :title="iconPreviewName" :visible.sync="iconPreviewVisible" width="360px"
                append-to-body custom-class="icon-preview-dialog" :show-close="true">
                <div class="icon-preview-content">
                    <img v-if="iconPreviewUrl" v-oss-src="iconPreviewUrl" :alt="iconPreviewName">
                </div>
            </el-dialog>

        </section>

        <!-- 导入 -->
        <import-result-dialog
            :visible.sync="importResultVisible"
            :result="importResult"
        />

        <el-dialog :visible.sync="evalImportDialogVisible" width="860px" custom-class="person-import-dialog"
            :close-on-click-modal="false" append-to-body @closed="onEvalImportDialogClosed">
            <div slot="title" class="pi-dialog-title">
                <span class="pi-dialog-title__icon"><i class="el-icon-s-data"></i></span>
                <div>
                    <strong>批量导入评价维度</strong>
                    <p>下载模板填写后上传，学校以顶部所选为准</p>
                </div>
            </div>
            <div class="pi-body">
                <div class="pi-steps">
                    <div class="pi-step"><span class="pi-step__no">1</span><div><strong>下载模板</strong><em>按列填写维度与评价项</em></div></div>
                    <i class="el-icon-arrow-right pi-step__arrow"></i>
                    <div class="pi-step"><span class="pi-step__no">2</span><div><strong>上传 Excel</strong><em>支持 .xlsx / .xls</em></div></div>
                    <i class="el-icon-arrow-right pi-step__arrow"></i>
                    <div class="pi-step"><span class="pi-step__no">3</span><div><strong>核对导入</strong><em>预览后再确认写入</em></div></div>
                </div>
                <button type="button" class="pi-template-card" @click="downloadEvalImportTemplate">
                    <span class="pi-template-card__icon"><i class="el-icon-document"></i></span>
                    <span class="pi-template-card__meta">
                        <strong>评价维度批量导入模板.xlsx</strong>
                        <em>含「填写说明」与示例行（固定/最大/分数范围）；无需填写学校</em>
                    </span>
                    <span class="pi-template-card__action"><i class="el-icon-download"></i>下载模板</span>
                </button>
                <el-upload :key="'eval-upload-' + evalImportUploadKey" class="pi-upload" drag action="#"
                    :auto-upload="false" :limit="1" :show-file-list="false" accept=".xlsx,.xls"
                    :on-change="onEvalImportFileChange" :on-remove="onEvalImportFileRemove" :on-exceed="onEvalImportExceed">
                    <div v-if="evalImportFileRaw" class="pi-upload__file">
                        <i class="el-icon-success pi-upload__ok"></i>
                        <div><strong>{{ evalImportFileRaw.name }}</strong><em>已选择，点击「解析并预览」</em></div>
                    </div>
                    <div v-else class="pi-upload__empty">
                        <i class="el-icon-upload2"></i><strong>点击选择或拖拽 Excel 到此处</strong><em>仅支持 .xlsx / .xls</em>
                    </div>
                </el-upload>
            </div>
            <div slot="footer" class="pi-footer">
                <el-button @click="evalImportDialogVisible = false">关闭</el-button>
                <el-button type="primary" icon="el-icon-view" :disabled="!evalImportFileRaw"
                    :loading="evalImportParsing" @click="parseEvalImportFile">解析并预览</el-button>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="excelShow" :close-on-click-modal="false" width="78%"
            custom-class="person-import-dialog" append-to-body
            :before-close="(done) => { this.backToEvalImportSelect(); done(); }">
            <div slot="title" class="pi-dialog-title">
                <span class="pi-dialog-title__icon"><i class="el-icon-document-checked"></i></span>
                <div><strong>评价维度导入核对</strong><p>共 {{ outputs.length }} 条，确认无误后写入系统</p></div>
            </div>
            <el-table :data="pagedOutputs" class="pi-preview-table" border stripe style="width: 100%" max-height="520">
                <el-table-column prop="ParentDimension" label="父级维度" min-width="100" show-overflow-tooltip />
                <el-table-column prop="Dimension" label="评价维度" min-width="100" show-overflow-tooltip />
                <el-table-column prop="Item" label="评价项目" min-width="120" show-overflow-tooltip />
                <el-table-column prop="ItemType" label="项目类型" width="100" show-overflow-tooltip />
                <el-table-column prop="ScoreMode" label="评分方式" width="100" show-overflow-tooltip />
                <el-table-column prop="MinScore" label="最低分" width="80" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{ scope.row.MinScore === null || scope.row.MinScore === undefined || scope.row.MinScore === '' ? '-' : scope.row.MinScore }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="ScoreValue" label="项目分值" width="90" show-overflow-tooltip />
                <el-table-column label="操作" align="center" width="90">
                    <template slot-scope="scope">
                        <el-button type="text" class="pi-row-del" @click="removeImport(scope)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pi-preview-pager">
                <el-pagination local-paging layout="total, prev, pager, next, jumper" :total="outputs.length"
                    :page-size="importPageSize" :current-page.sync="importPage"
                    @current-change="handleImportCurrentChange" @size-change="handleImportSizeChange" />
            </div>
            <div slot="footer" class="pi-footer">
                <el-button @click="backToEvalImportSelect">返回上一步</el-button>
                <el-button type="primary" icon="el-icon-upload2" :disabled="!outputs.length" @click="SavaImport">确认导入</el-button>
            </div>
        </el-dialog>

    </section>
</template>

<script>
import util from "../../../util/date";
import { getEvaluationDimensionListPage, editEvaluationDimension, addEvaluationDimension, deleteEvaluationDimension, getStudentEvaluationItemListPage, editStudentEvaluationItem, addStudentEvaluationItem, deleteStudentEvaluationItem, getEvaluationIcons, uploadEvaluationIcon, deleteEvaluationIcon, importEvaluationDimensions, getEvaluationDimensionParentsByDepartment, getEvaluationRoles, getEvaluationDimensionPermissions, getEvaluationDimensionPermissionsBatch, saveEvaluationDimensionPermissions } from '../../api/modules/moral-education';
import { BaseApiUrl } from '../../api/base';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import ImportResultDialog from '../../components/ImportResultDialog'
import { normalizeImportBatchResponse } from '../../utils/importResultParser'
import { read, utils, writeFile } from 'xlsx'
import '../../style/person-import-dialog.css'
import { deptIdsEqual as isDeptIdEqual, normalizeDeptId, treeNodeDeptId } from '../../utils/deptCascaderProps'

export default {
    components: { Toolbar, DepartmentPane, ImportResultDialog },
    data() {
        return {
            filters: {},
            searchList: [
                {
                    label: '名称',
                    key: 'name',
                },
            ],
            dimensions: [],
            expandedGroups: {},
            items: [],
            total: 0,
            buttonList: [],
            currentRow: null,
            currentDimension: null,
            currentRootDimension: null,
            page: 1,
            PageSize: 10,
            listLoading: false,
            itemsLoading: false,
            DepartmentId: 0,
            BaseApiUrl: BaseApiUrl, //网络前缀
            itemsDialogVisible: false,
            // 维度编辑相关
            editFormVisible: false,
            editLoading: false,
            dialogTitle: '',
            editFormRules: {
                Name: [{ required: true, message: "请输入维度名称", trigger: "blur" }],
                ParentId: [
                    { required: true, message: '请选择父级维度', trigger: 'change' }
                ],
            },
            editForm: {
                Id: 0,
                Name: '',
                DepartmentId: 0,
                Icon: '',
                DepartmentName: '',
                ParentId: null,
                Level: 1,
                SortOrder: 0,
                NotifyClassTeacherOnDeduct: false,
                ScoreAlertWeekThreshold: undefined,
                ScoreAlertMonthThreshold: undefined,
                ScoreAlertSemesterThreshold: undefined,
                ScoreAlertNotifyTeacher: true,
                ScoreAlertNotifyParent: false,
            },

            // 评价项编辑相关
            editItemFormVisible: false,
            editItemLoading: false,
            editItemFormRules: {
                Name: [{ required: true, message: "请输入评价项名称", trigger: "blur" }],
                ItemKind: [{ required: true, message: "请选择项目分组", trigger: "change" }],
                ScoreMode: [{ required: true, message: "请选择分值模式", trigger: "change" }],
                ScoreValue: [
                    { required: true, message: "请输入分值", trigger: "blur" },
                    { type: 'number', message: "请输入有效的数字", trigger: "blur" }
                ],
            },
            editItemForm: {
                Id: 0,
                Name: '',
                DimensionId: 0,
                SortOrder: 0,
                ItemKind: "Praise",
                ScoreMode: "Fixed",
                ScoreValue: 0,
                MinScore: 0,
                Icon: '',
                IconSource: 'Custom',
                IsPushToParent: true,
            },

            // 评价项新增相关
            addItemFormVisible: false,
            addItemLoading: false,
            addItemFormRules: {
                Name: [{ required: true, message: "请输入评价项名称", trigger: "blur" }],
                ItemKind: [{ required: true, message: "请选择项目分组", trigger: "change" }],
                ScoreMode: [{ required: true, message: "请选择分值模式", trigger: "change" }],
                ScoreValue: [
                    { required: true, message: "请输入分值", trigger: "blur" },
                    { type: 'number', message: "请输入有效的数字", trigger: "blur" }
                ],
            },
            addItemForm: {
                Name: '',
                DimensionId: 0,
                SortOrder: 0,
                ItemKind: "Praise",
                ScoreMode: "Fixed",
                ScoreValue: 0,
                MinScore: 0,
                Icon: '',
                IconSource: 'Level2',
                IsPushToParent: true,
            },

            activeTab: 'praise',
            praiseItems: [],
            improvementItems: [],
            // 表扬项分页
            praisePage: 1,
            praisePageSize: 5,
            praiseTotal: 0,
            // 待改进项分页
            improvementPage: 1,
            improvementPageSize: 5,
            improvementTotal: 0,

            iconList: [
            ],
            showIconLib: false,
            iconLibType: 'Dimension',
            iconPickerTarget: '',
            iconLibraryTab: 'all',
            pickerSelectedIcon: null,
            iconUploadDialogVisible: false,
            iconUploadFile: null,
            iconUploadLoading: false,
            iconPreviewVisible: false,
            iconPreviewUrl: '',
            iconPreviewName: '',
            advancedSettingsExpanded: false,
            dimensionSettingsTab: 'basic',

            parentCategories: [],

            roleOptions: [],
            roleOptionsLoading: false,
            editFormRoleIds: [],
            dimensionPermissionMap: {},

            //excel
            outputs: [],
            excelShow: false,
            evalImportDialogVisible: false,
            evalImportFileRaw: null,
            evalImportParsing: false,
            evalImportUploadKey: 0,
            evalImportKeepFileOnClose: false,
            importResultVisible: false,
            importResult: null,
            // 导入分页
            importPage: 1,
            importPageSize: 10,
        };
    },
    computed: {
        pagedOutputs() {
            const start = (this.importPage - 1) * this.importPageSize;
            return (this.outputs || []).slice(start, start + this.importPageSize);
        },
        enabledRoleOptions() {
            return (this.roleOptions || []).filter(r => r.Enabled !== false);
        },
        /** 可见角色超过 4 个时再折叠为 +N，少量选中时全部展示 */
        shouldCollapseEditFormRoleTags() {
            return (this.editFormRoleIds || []).length > 4;
        },
        filteredIconList() {
            const icons = this.iconList || [];
            if (this.iconLibraryTab === 'school') {
                return icons.filter(icon => isDeptIdEqual(icon.DepartmentId, this.DepartmentId));
            }
            return icons;
        }
    },
    methods: {
        isDeptIdEqual(left, right) {
            return isDeptIdEqual(left, right);
        },
        isGroupOpen(id) {
            return !!(this.expandedGroups && this.expandedGroups[id]);
        },
        toggleGroup(id) {
            if (!this.expandedGroups) this.$set(this, 'expandedGroups', {});
            this.$set(this.expandedGroups, id, !this.expandedGroups[id]);
        },
        loadIconList(type = 'Dimension') {
            return getEvaluationIcons({
                iconType: type,
                departmentId: this.DepartmentId
            }).then(res => {
                if (res.data && res.data.success) {
                    this.iconList = res.data.response || [];
                    if (type === 'Dimension'
                        && this.editForm
                        && !this.editForm.Id
                        && this.editForm.Level === 1
                        && !this.editForm.Icon
                        && this.iconList.length) {
                        const defaultIcon = this.iconList.find(icon => Number(icon.DepartmentId) === -1)
                            || this.iconList[0];
                        this.editForm.Icon = defaultIcon.IconUrl;
                    }
                }
            });
        },

        openIconPicker(type, target) {
            this.iconLibType = type;
            this.iconPickerTarget = target;
            this.pickerSelectedIcon = null;
            this.iconLibraryTab = 'all';
            this.iconUploadDialogVisible = false;
            this.iconUploadFile = null;
            if (this.$refs.iconUpload) {
                this.$refs.iconUpload.clearFiles();
            }
            this.loadIconList(type).then(() => {
                const currentIcon = this.getPickerCurrentIcon();
                this.pickerSelectedIcon = (this.iconList || []).find(icon =>
                    icon.IconUrl === currentIcon
                ) || null;
                this.showIconLib = true;
            });
        },

        getPickerCurrentIcon() {
            if (this.iconPickerTarget === 'dimension') return this.editForm.Icon;
            if (this.iconPickerTarget === 'editItem') return this.editItemForm.Icon;
            return this.addItemForm.Icon;
        },

        openIconUpload() {
            this.iconLibraryTab = 'school';
            this.iconUploadDialogVisible = true;
            this.iconUploadFile = null;
            if (this.$refs.iconUpload) {
                this.$refs.iconUpload.clearFiles();
            }
        },

        handleIconLibraryTabChange(tab) {
            if (tab !== 'school') {
                this.iconUploadFile = null;
                if (this.$refs.iconUpload) {
                    this.$refs.iconUpload.clearFiles();
                }
            }
        },

        isPickerIconSelected(icon) {
            return !!(this.pickerSelectedIcon && this.pickerSelectedIcon.IconUrl === icon.IconUrl);
        },

        selectPickerIcon(icon) {
            this.pickerSelectedIcon = icon;
        },

        confirmPickerIcon() {
            if (!this.pickerSelectedIcon) return;
            const iconUrl = this.pickerSelectedIcon.IconUrl;
            if (this.iconPickerTarget === 'dimension') {
                this.editForm.Icon = iconUrl;
            } else if (this.iconPickerTarget === 'editItem') {
                this.editItemForm.Icon = iconUrl;
            } else {
                this.addItemForm.Icon = iconUrl;
            }
            this.showIconLib = false;
        },

        removeSchoolIcon(icon) {
            this.$confirm('删除后该校将无法继续使用此图标，确认删除吗？', '删除本校图标', {
                type: 'warning'
            }).then(() => {
                return deleteEvaluationIcon({
                    id: icon.Id,
                    departmentId: this.DepartmentId
                });
            }).then(res => {
                if (res.data && res.data.success) {
                    this.$message.success('图标已删除');
                    if (this.pickerSelectedIcon && this.pickerSelectedIcon.Id === icon.Id) {
                        this.pickerSelectedIcon = null;
                    }
                    return this.loadIconList(this.iconLibType);
                }
                this.$message.error((res.data && res.data.msg) || '图标删除失败');
            }).catch(() => {});
        },

        handleIconUploadChange(file, fileList) {
            const rawFile = file && file.raw;
            if (!rawFile) return;
            if (rawFile.size > 2 * 1024 * 1024) {
                this.$message.error('图标大小不能超过 2MB');
                fileList.splice(0, fileList.length);
                this.iconUploadFile = null;
                return;
            }
            this.iconUploadFile = rawFile;
        },

        handleIconUploadExceed() {
            this.$message.warning('一次只能选择一个图标');
        },

        async uploadIconSubmit() {
            if (!this.iconUploadFile) return;
            const formData = new FormData();
            formData.append('file', this.iconUploadFile);
            formData.append('iconType', this.iconLibType);
            formData.append('departmentId', this.DepartmentId);
            this.iconUploadLoading = true;
            uploadEvaluationIcon(formData).then(async res => {
                if (res.data && res.data.success && res.data.response) {
                    const uploadedIcon = res.data.response;
                    this.pickerSelectedIcon = uploadedIcon;
                    this.$message.success('图标上传成功');
                    this.iconUploadDialogVisible = false;
                    this.iconUploadFile = null;
                    await this.loadIconList(this.iconLibType);
                    this.pickerSelectedIcon = (this.iconList || []).find(icon =>
                        icon.IconUrl === uploadedIcon.IconUrl
                    ) || uploadedIcon;
                } else {
                    this.$message.error((res.data && res.data.msg) || '图标上传失败');
                }
            }).catch(() => {
                this.$message.error('图标上传失败');
            }).finally(() => {
                this.iconUploadLoading = false;
            });
        },
        treeNodeClick(data, node, component) {
            this.DepartmentId = treeNodeDeptId(data)
            this.loadRoleOptions()
            this.handleQuery()
        },

        /** 有效学校/部门 Id（字符串）。最后修改：2026-10-18 */
        positiveDeptId(v) {
            const id = normalizeDeptId(v);
            return id || null;
        },

        loadRoleOptions() {
            const schoolId = this.positiveDeptId(this.DepartmentId);
            if (!schoolId) {
                this.roleOptions = [];
                return;
            }
            this.roleOptionsLoading = true;
            getEvaluationRoles({ schoolDepartmentId: schoolId }).then(res => {
                this.roleOptionsLoading = false;
                if (res.data && res.data.success) {
                    this.roleOptions = res.data.response || [];
                } else {
                    this.roleOptions = [];
                }
            }).catch(() => {
                this.roleOptionsLoading = false;
                this.roleOptions = [];
            });
        },

        flattenDimensionRows(rows) {
            const out = [];
            (rows || []).forEach(row => {
                out.push(row);
                if (Array.isArray(row.Children)) {
                    row.Children.forEach(child => out.push(child));
                }
            });
            return out;
        },

        loadDimensionPermissionLabels() {
            const schoolId = this.positiveDeptId(this.DepartmentId);
            if (!schoolId) {
                this.dimensionPermissionMap = {};
                return Promise.resolve();
            }
            const rows = this.flattenDimensionRows(this.dimensions);
            const targets = rows.filter(r => r && r.Id);
            if (!targets.length) {
                this.dimensionPermissionMap = {};
                return Promise.resolve();
            }
            return getEvaluationDimensionPermissionsBatch({
                SchoolDepartmentId: schoolId,
                DimensionIds: targets.map(row => row.Id)
            }).then(res => {
                const map = {};
                if (!res.data || !res.data.success) {
                    this.dimensionPermissionMap = map;
                    return;
                }
                const result = res.data.response || {};
                const permissions = result.Permissions || result.permissions || [];
                permissions.forEach(perm => {
                    const dimensionId = perm.DimensionId || perm.dimensionId;
                    if (dimensionId) map[dimensionId] = perm;
                });
                this.dimensionPermissionMap = map;
            }).catch(() => {
                this.dimensionPermissionMap = {};
            });
        },

        getRoleNameById(roleId) {
            const role = (this.roleOptions || []).find(r => Number(r.Id) === Number(roleId));
            return role ? role.Name : '';
        },

        /** 维度是否已在后台显式配置可见角色。最后修改：2026-08-29 */
        hasExplicitDimensionPerm(perm) {
            if (!perm) return false;
            if (perm.HasExplicitConfig === true || perm.hasExplicitConfig === true) return true;
            const roleIds = perm.RoleIds || perm.roleIds || [];
            return roleIds.length > 0;
        },

        getVisibleRoleText(row) {
            if (!row || !row.Id) return '-';
            const perm = this.dimensionPermissionMap[row.Id] || {};
            const roleIds = perm.RoleIds || perm.roleIds || [];
            const isLevel2 = row.Level === 2 || !!row.ParentId;
            if (!this.hasExplicitDimensionPerm(perm)) {
                return isLevel2 ? '继承父级' : '全体教职工';
            }
            if (!roleIds.length) {
                return '已配置';
            }
            const names = roleIds.map(id => this.getRoleNameById(id)).filter(Boolean);
            return names.length ? names.join('、') : '已配置';
        },

        loadEditFormRoleIds(dimensionId) {
            const schoolId = this.positiveDeptId(this.editForm.DepartmentId || this.DepartmentId);
            this.editFormRoleIds = [];
            if (!schoolId || !dimensionId) return Promise.resolve();
            return getEvaluationDimensionPermissions({
                schoolDepartmentId: schoolId,
                dimensionId
            }).then(res => {
                if (res.data && res.data.success) {
                    const perm = res.data.response || {};
                    this.editFormRoleIds = this.hasExplicitDimensionPerm(perm)
                        ? (perm.RoleIds || perm.roleIds || [])
                        : [];
                    this.$set(this.dimensionPermissionMap, dimensionId, perm);
                }
            }).catch(() => { });
        },

        saveDimensionRolePermissions(dimensionId) {
            const schoolId = this.positiveDeptId(this.editForm.DepartmentId || this.DepartmentId);
            if (!schoolId || !dimensionId) return Promise.resolve({ success: true });
            return saveEvaluationDimensionPermissions({
                SchoolDepartmentId: schoolId,
                DimensionId: dimensionId,
                RoleIds: this.editFormRoleIds || []
            }).then(res => {
                if (res.data && res.data.success) {
                    return { success: true };
                }
                return { success: false, msg: (res.data && res.data.msg) || '角色权限保存失败' };
            }).catch(() => ({ success: false, msg: '角色权限保存失败' }));
        },

        formatScoreModeLabel(mode) {
            if (mode === 'Fixed') return '固定值';
            if (mode === 'Max') return '最大值';
            if (mode === 'Range') return '分数范围';
            return mode || '-';
        },

        formatItemScoreText(row) {
            const sign = row.ItemKind === 'Praise' ? '+' : '-';
            const maxVal = row.ScoreValue;
            if (row.ScoreMode === 'Max') {
                return `${sign}0～${maxVal}分`;
            }
            if (row.ScoreMode === 'Range') {
                const minVal = row.MinScore != null ? row.MinScore : 0;
                return `${sign}${minVal}～${maxVal}分`;
            }
            return `${sign}${maxVal}分`;
        },

        validateItemScoreForm(form) {
            if (form.ScoreMode === 'Range') {
                const minScore = Number(form.MinScore);
                const maxScore = Number(form.ScoreValue);
                if (Number.isNaN(minScore) || Number.isNaN(maxScore)) {
                    this.$message.warning('分数范围模式下须填写最低分和最高分');
                    return false;
                }
                if (minScore < 0 || minScore > maxScore) {
                    this.$message.warning('最低分须大于等于 0 且小于等于最高分');
                    return false;
                }
            }
            return true;
        },

        handleQuery(keepExpanded = true) {
            let para = {
                departmentId: this.DepartmentId,
                page: this.page,
                intPageSize: this.PageSize,
                ...this.filters,
            }
            this.listLoading = true;
            getEvaluationDimensionListPage(para).then((res) => {
                this.total = res.data.response.dataCount
                this.PageSize = res.data.response.PageSize
                this.dimensions = res.data.response.data || []
                this.listLoading = false
                this.loadDimensionPermissionLabels();
                const hasKeyword = !!(this.filters && this.filters.name && String(this.filters.name).trim());
                if (hasKeyword) {
                    const expanded = { ...(this.expandedGroups || {}) };
                    (this.dimensions || []).forEach(item => {
                        if (item && item.Id) expanded[item.Id] = true;
                    });
                    this.expandedGroups = expanded;
                } else if (keepExpanded) {
                    const nextExpanded = { ...(this.expandedGroups || {}) };
                    this.expandedGroups = nextExpanded;
                } else {
                    this.expandedGroups = {};
                }
            });
        },

        handleCurrentChange(val) {
            this.page = val;
            this.handleQuery(true);
        },

        /** 红线留空或 0 表示关闭。创建于 2026-09-24 */
        normalizeAlertThreshold(value) {
            if (value === '' || value === null || value === undefined) return null;
            const n = Number(value);
            if (!Number.isFinite(n) || n <= 0) return null;
            return Math.round(n * 100) / 100;
        },

        /** 未配置的红线在数字框中显示为空 */
        blankClosedAlertThresholds() {
            ['ScoreAlertWeekThreshold', 'ScoreAlertMonthThreshold', 'ScoreAlertSemesterThreshold'].forEach((key) => {
                if (!(Number(this.editForm[key]) > 0)) this.$set(this.editForm, key, undefined);
            });
        },

        /** 一级维度是否配置了任意一条红线 */
        hasScoreAlert(row) {
            if (!row) return false;
            return [row.ScoreAlertWeekThreshold, row.ScoreAlertMonthThreshold, row.ScoreAlertSemesterThreshold]
                .some((value) => Number(value) > 0);
        },

        handleSizeChange(val) {
            this.PageSize = val;
            this.handleQuery(true);
        },

        handleAdd() {
            if (!this.DepartmentId || this.DepartmentId === 0 || this.DepartmentId === '0') {
                this.$message.warning('请先在左侧选择具体的学校机构！');
                return;
            }
            this.dialogTitle = '新增评价维度';
            this.editFormVisible = true;
            this.advancedSettingsExpanded = false;
            this.dimensionSettingsTab = 'basic';
            this.editForm = {
                Id: 0,
                Name: '',
                DepartmentId: this.DepartmentId,
                Icon: '',
                IconSource: 'Custom',
                DepartmentName: '',
                ParentId: null,
                Level: 1,
                SortOrder: 0,
                NotifyClassTeacherOnDeduct: false,
                ScoreAlertWeekThreshold: undefined,
                ScoreAlertMonthThreshold: undefined,
                ScoreAlertSemesterThreshold: undefined,
                ScoreAlertNotifyTeacher: true,
                ScoreAlertNotifyParent: false,
            };
            this.editFormRoleIds = [];
            this.loadIconList('Dimension'); // 只查维度图标
        },

        handleEdit(row) {
            this.dialogTitle = '编辑评价维度';
            this.editFormVisible = true;
            this.advancedSettingsExpanded = false;
            this.dimensionSettingsTab = 'basic';
            this.editForm = Object.assign({
                DepartmentName: row.DepartmentName,
                ParentId: row.ParentId || null,
                IconSource: row.IconSource || (row.ParentId ? 'Parent' : 'Custom'),
                Level: row.ParentId ? 2 : 1,
                SortOrder: 0,
                NotifyClassTeacherOnDeduct: false,
                ScoreAlertNotifyTeacher: true,
                ScoreAlertNotifyParent: false,
            }, row);
            if (this.editForm.SortOrder == null) this.editForm.SortOrder = 0;
            this.blankClosedAlertThresholds();

            // 如果是二级项，加载该部门下的父级维度
            if (this.editForm.Level === 2) {
                this.loadParentCategories(this.editForm.DepartmentId || this.DepartmentId);
            }

            this.loadEditFormRoleIds(row.Id);
            this.loadIconList('Dimension'); // 只查维度图标
        },

        loadParentCategories(departmentId) {
            if (!departmentId) return;
            getEvaluationDimensionParentsByDepartment({ departmentId }).then((res) => {
                if (res.data && res.data.success) {
                    this.parentCategories = res.data.response || [];
                }
            });
        },

        getParentDimension() {
            return (this.parentCategories || []).find(p => Number(p.Id) === Number(this.editForm.ParentId)) || null;
        },

        getParentIcon() {
            const parent = this.getParentDimension();
            return parent ? parent.Icon : '';
        },

        getParentName() {
            const parent = this.getParentDimension();
            return parent ? parent.Name : '未选择父级';
        },

        handleDimensionIconSourceChange(source) {
            if (source === 'Parent') {
                this.editForm.Icon = '';
            }
        },

        getItemPreviewIcon(item) {
            if (!item) return '';
            if (item.IconSource === 'Custom') return item.Icon || '';
            if (item.IconSource === 'Level1') {
                return this.currentRootDimension ? this.currentRootDimension.Icon : '';
            }
            return this.getDimensionEffectiveIcon(this.currentDimension);
        },

        /** 评价项继承图标时的说明文案。最后修改：2026-10-17 */
        getItemInheritLabel(item) {
            if (!item) return '';
            if (item.IconSource === 'Level1') {
                const name = this.currentRootDimension ? this.currentRootDimension.Name : '一级维度';
                return `跟随一级：${name}`;
            }
            const name = this.currentDimension ? this.currentDimension.Name : '二级维度';
            return `跟随二级：${name}`;
        },

        getDimensionEffectiveIcon(dimension) {
            if (!dimension) return '';
            if (dimension.IconSource !== 'Parent') return dimension.Icon || '';
            return this.currentRootDimension ? this.currentRootDimension.Icon : '';
        },

        getListDimensionIcon(dimension, root) {
            if (!dimension) return '';
            if (dimension.IconSource === 'Parent') {
                return root ? (root.Icon || '') : '';
            }
            return dimension.Icon || '';
        },

        openIconPreview(iconUrl, name) {
            if (!iconUrl) return;
            this.iconPreviewUrl = iconUrl;
            this.iconPreviewName = name || '评价图标';
            this.iconPreviewVisible = true;
        },

        handleItemIconSourceChange(item) {
            if (item && item.IconSource !== 'Custom') {
                item.Icon = '';
            }
        },

        // 顶部新增二级维度
        handleAddSub() {
            if (!this.DepartmentId || this.DepartmentId === 0 || this.DepartmentId === '0') {
                this.$message.warning('请先在左侧选择具体的学校机构！');
                return;
            }
            this.dialogTitle = '新增子维度';
            this.editFormVisible = true;
            this.parentCategories = [];
            this.editForm = {
                Id: 0,
                Name: '',
                DepartmentId: this.DepartmentId,
                Icon: '',
                IconSource: 'Parent',
                DepartmentName: '',
                ParentId: null,
                Level: 2,
                SortOrder: 0,
            };
            this.editFormRoleIds = [];

            this.loadParentCategories(this.DepartmentId);
            this.loadIconList('Dimension');
        },

        // 从行新增子维度
        handleAddSub1(row) {
            this.dialogTitle = '新增子维度';
            this.editFormVisible = true;
            this.editForm = {
                Id: 0,
                Name: '',
                DepartmentId: row.DepartmentId,
                Icon: '',
                IconSource: 'Parent',
                DepartmentName: row.DepartmentName,
                ParentId: row.Id,
                Level: 2,
                SortOrder: 0,
            };
            this.editFormRoleIds = [];

            this.loadParentCategories(row.DepartmentId);
            this.loadIconList('Dimension');
        },

        editSubmit() {
            this.$refs.editForm.validate((valid) => {
                if (valid) {
                    const iconSource = this.editForm.Level === 1 ? 'Custom' : (this.editForm.IconSource || 'Custom');
                    if (iconSource === 'Custom' && !String(this.editForm.Icon || '').trim()) {
                        this.$message.warning('请选择维度图标');
                        return;
                    }
                    if (iconSource === 'Parent' && !this.editForm.ParentId) {
                        this.$message.warning('请先选择父级维度');
                        return;
                    }
                    this.$confirm("确认提交吗？", "提示", {}).then(() => {
                        this.editLoading = true;
                        let para = Object.assign({}, this.editForm);
                        para.IconSource = iconSource;
                        if (para.IconSource === 'Parent') {
                            para.Icon = '';
                        }

                        // 新增时直接使用当前选中的学校 ID
                        if (!para.Id && !para.DepartmentId) {
                            para.DepartmentId = this.DepartmentId;
                        }

                        // 若是一级，确保没有 ParentId；若是二级，保持 ParentId（可以为 null）
                        if (para.Level === 1) {
                            para.ParentId = null;
                            para.NotifyClassTeacherOnDeduct = !!para.NotifyClassTeacherOnDeduct;
                            para.ScoreAlertNotifyTeacher = para.ScoreAlertNotifyTeacher !== false;
                            para.ScoreAlertNotifyParent = !!para.ScoreAlertNotifyParent;
                            para.ScoreAlertWeekThreshold = this.normalizeAlertThreshold(para.ScoreAlertWeekThreshold);
                            para.ScoreAlertMonthThreshold = this.normalizeAlertThreshold(para.ScoreAlertMonthThreshold);
                            para.ScoreAlertSemesterThreshold = this.normalizeAlertThreshold(para.ScoreAlertSemesterThreshold);
                        } else if (para.Level === 2 && !para.ParentId) {
                            para.ParentId = null;
                        }

                        const apiCall = para.Id ? editEvaluationDimension : addEvaluationDimension;

                        apiCall(para).then((res) => {
                            if (util.isEmt.format(res)) {
                                this.editLoading = false;
                                return;
                            }
                            if (res.data.success) {
                                const dimensionId = para.Id || (res.data.response && (res.data.response.Id || res.data.response));
                                this.saveDimensionRolePermissions(dimensionId).then(permRes => {
                                    this.editLoading = false;
                                    if (permRes.success) {
                                        this.$message({
                                            message: res.data.msg,
                                            type: "success",
                                        });
                                    } else {
                                        this.$message({
                                            message: `维度已保存，但${permRes.msg}`,
                                            type: "warning",
                                        });
                                    }
                                    this.$refs["editForm"].resetFields();
                                    this.editFormVisible = false;

                                    const targetParentId = para.Level === 2 ? para.ParentId : null;
                                    const newId = dimensionId;
                                    if (targetParentId) {
                                        this.$set(this.expandedGroups, targetParentId, true);
                                    } else if (newId) {
                                        this.$set(this.expandedGroups, newId, true);
                                    }

                                    this.handleQuery(true);
                                });
                            } else {
                                this.$message({
                                    message: res.data.msg,
                                    type: "error",
                                });
                                this.editLoading = false;
                            }
                        });
                    });
                }
            });
        },

        handleDel(row) {
            this.$confirm("确认删除该记录吗?", "提示", {
                type: "warning",
            })
                .then(() => {
                    this.listLoading = true;
                    let para = { id: row.Id };
                    deleteEvaluationDimension(para).then((res) => {
                        if (util.isEmt.format(res)) {
                            this.listLoading = false;
                            return;
                        }
                        this.listLoading = false;
                        if (res.data.success) {
                            this.$message({
                                message: "删除成功",
                                type: "success",
                            });
                        } else {
                            this.$message({
                                message: res.data.msg,
                                type: "error",
                            });
                        }
                        this.handleQuery();
                    });
                })
                .catch(() => { });
        },

        handleItems(row) {
            this.currentDimension = row;
            this.currentRootDimension = (this.dimensions || []).find(root =>
                (root.Children || []).some(child => Number(child.Id) === Number(row.Id))
            ) || null;
            // 重置分页和数据，防止显示上一次的数据
            this.praisePage = 1;
            this.improvementPage = 1;
            this.praiseTotal = 0;
            this.improvementTotal = 0;
            this.praiseItems = [];
            this.improvementItems = [];

            // 强制切换到表扬标签，并先加载表扬项，避免打开时表格为空
            this.activeTab = 'praise';
            this.getItems();
            this.itemsDialogVisible = true;
        },

        getItems() {

            // 获取表扬项总数
            let praisePara = {
                dimensionId: this.currentDimension.Id,
                itemKind: 'praise',
                page: 1,
                intPageSize: 1, // 只需要获取总数
            }
            getStudentEvaluationItemListPage(praisePara).then((res) => {
                this.praiseTotal = res.data.response.dataCount;
            });

            // 获取待改进项总数
            let improvementPara = {
                dimensionId: this.currentDimension.Id,
                itemKind: 'improvement',
                page: 1,
                intPageSize: 1, // 只需要获取总数
            }
            getStudentEvaluationItemListPage(improvementPara).then((res) => {
                this.improvementTotal = res.data.response.dataCount;
            });

            // 根据当前tab获取对应数据
            if (this.activeTab === 'praise') {
                this.getPraiseItems();
            } else {
                this.getImprovementItems();
            }
        },

        getPraiseItems() {
            let para = {
                dimensionId: this.currentDimension.Id,
                itemKind: "praise",
                page: this.praisePage,
                intPageSize: this.praisePageSize,
            }
            this.itemsLoading = true;
            getStudentEvaluationItemListPage(para).then((res) => {
                const data = res.data.response.data || [];
                // 将后台的 1/0 或 true/false 统一为布尔，便于开关控件使用
                this.praiseItems = data.map(item => {
                    item.IsPushToParent = (item.IsPushToParent === 1 || item.IsPushToParent === true);
                    return item;
                });
                this.praiseTotal = res.data.response.dataCount;
                this.praisePageSize = res.data.response.PageSize;
                this.itemsLoading = false;
            });
        },

        getImprovementItems() {
            let para = {
                dimensionId: this.currentDimension.Id,
                itemKind: "improvement",
                page: this.improvementPage,
                intPageSize: this.improvementPageSize,
            }
            this.itemsLoading = true;
            getStudentEvaluationItemListPage(para).then((res) => {
                const data = res.data.response.data || [];
                this.improvementItems = data.map(item => {
                    item.IsPushToParent = (item.IsPushToParent === 1 || item.IsPushToParent === true);
                    return item;
                });
                this.improvementTotal = res.data.response.dataCount;
                this.improvementPageSize = res.data.response.PageSize;
                this.itemsLoading = false;
            });
        },

        handleTabClick(tab) {
            if (tab.name === 'praise') {
                this.getPraiseItems();
            } else {
                this.getImprovementItems();
            }
        },

        handlePraiseCurrentChange(val) {
            this.praisePage = val;
            this.getPraiseItems();
        },

        handlePraiseSizeChange(val) {
            this.praisePageSize = val;
            this.praisePage = 1;
            this.getPraiseItems();
        },

        handleImprovementCurrentChange(val) {
            this.improvementPage = val;
            this.getImprovementItems();
        },

        handleImprovementSizeChange(val) {
            this.improvementPageSize = val;
            this.improvementPage = 1;
            this.getImprovementItems();
        },

        handleAddItem() {
            this.addItemFormVisible = true;
            this.addItemForm = {
                Name: '',
                DimensionId: this.currentDimension.Id,
                SortOrder: 0,
                ItemKind: "Praise",
                ScoreMode: "Fixed",
                ScoreValue: 0,
                MinScore: 0,
                Icon: '',
                IconSource: 'Level2',
                IsPushToParent: true
            };
            this.loadIconList('Item'); // 只查学生评价项图标
        },

        handleEditItem(row) {
            if (!row) {
                this.$message({
                    message: "请选择要编辑的一行数据！",
                    type: "error",
                });
                return;
            }
            this.editItemForm = Object.assign({}, row);
            this.editItemForm.IconSource = row.IconSource || (row.Icon ? 'Custom' : 'Level2');
            if (this.editItemForm.MinScore == null) {
                this.editItemForm.MinScore = 0;
            }
            if (this.editItemForm.SortOrder == null) {
                this.editItemForm.SortOrder = 0;
            }
            // 后端使用 1/0 存储，转换为布尔以便开关显示
            this.editItemForm.IsPushToParent = row.IsPushToParent === 1 || row.IsPushToParent === true;
            this.editItemFormVisible = true;
            this.loadIconList('Item'); // 只查学生评价项图标
        },

        editItemSubmit() {
            this.$refs.editItemForm.validate((valid) => {
                if (valid) {
                    const iconSource = this.editItemForm.IconSource || 'Custom';
                    if (iconSource === 'Custom' && !String(this.editItemForm.Icon || '').trim()) {
                        this.$message.warning('请选择评价项图标');
                        return;
                    }
                    if (!this.validateItemScoreForm(this.editItemForm)) return;
                    this.$confirm("确认提交吗？", "提示", {}).then(() => {
                        this.editItemLoading = true;
                        let para = Object.assign({}, this.editItemForm);
                        para.IconSource = iconSource;
                        if (para.IconSource !== 'Custom') {
                            para.Icon = '';
                        }
                        if (para.ScoreMode !== 'Range') {
                            para.MinScore = null;
                        }
                        // 后端需要 1/0 表示是否推送给家长
                        para.IsPushToParent = para.IsPushToParent ? 1 : 0;

                        const apiCall = para.Id ? editStudentEvaluationItem : addStudentEvaluationItem;

                        apiCall(para).then((res) => {
                            if (util.isEmt.format(res)) {
                                this.editItemLoading = false;
                                return;
                            }
                            if (res.data.success) {
                                this.editItemLoading = false;
                                this.$message({
                                    message: res.data.msg,
                                    type: "success",
                                });
                                this.$refs["editItemForm"].resetFields();
                                this.editItemFormVisible = false;
                                this.getItems();
                            } else {
                                this.$message({
                                    message: res.data.msg,
                                    type: "error",
                                });
                                this.editItemLoading = false;
                            }
                        });
                    });
                }
            });
        },

        handleDelItem(row) {
            if (!row) {
                this.$message({
                    message: "请选择要删除的一行数据！",
                    type: "error",
                });
                return;
            }
            this.$confirm("确认删除该记录吗?", "提示", {
                type: "warning",
            })
                .then(() => {
                    this.itemsLoading = true;
                    let para = { id: row.Id };
                    deleteStudentEvaluationItem(para).then((res) => {
                        if (util.isEmt.format(res)) {
                            this.itemsLoading = false;
                            return;
                        }
                        this.itemsLoading = false;
                        if (res.data.success) {
                            this.$message({
                                message: "删除成功",
                                type: "success",
                            });
                        } else {
                            this.$message({
                                message: res.data.msg,
                                type: "error",
                            });
                        }
                        this.getItems();
                    });
                })
                .catch(() => { });
        },

        addItemSubmit() {
            this.$refs.addItemForm.validate((valid) => {
                if (valid) {
                    const iconSource = this.addItemForm.IconSource || 'Level2';
                    if (iconSource === 'Custom' && !String(this.addItemForm.Icon || '').trim()) {
                        this.$message.warning('请选择评价项图标');
                        return;
                    }
                    if (!this.validateItemScoreForm(this.addItemForm)) return;
                    this.$confirm("确认提交吗？", "提示", {}).then(() => {
                        this.addItemLoading = true;
                        let para = Object.assign({}, this.addItemForm);
                        para.IconSource = iconSource;
                        if (para.IconSource !== 'Custom') {
                            para.Icon = '';
                        }
                        if (para.ScoreMode !== 'Range') {
                            para.MinScore = null;
                        }
                        // 后端需要 1/0 表示是否推送给家长
                        para.IsPushToParent = para.IsPushToParent ? 1 : 0;
                        addStudentEvaluationItem(para).then((res) => {
                            if (util.isEmt.format(res)) {
                                this.addItemLoading = false;
                                return;
                            }
                            if (res.data.success) {
                                this.addItemLoading = false;
                                this.$message({
                                    message: res.data.msg,
                                    type: "success",
                                });
                                this.$refs["addItemForm"].resetFields();
                                this.addItemFormVisible = false;
                                this.getItems();
                            } else {
                                this.$message({
                                    message: res.data.msg,
                                    type: "error",
                                });
                                this.addItemLoading = false;
                            }
                        });
                    });
                }
            });
        },

        // 切换行内推送开关
        togglePush(row) {
            const newVal = row.IsPushToParent ? 0 : 1;
            const para = { Id: row.Id, IsPushToParent: newVal };
            this.itemsLoading = true;
            editStudentEvaluationItem(para).then((res) => {
                this.itemsLoading = false;
                if (util.isEmt.format(res)) {
                    return;
                }
                if (res.data && res.data.success) {
                    row.IsPushToParent = newVal === 1;
                    this.$message({ message: res.data.msg, type: 'success' });
                } else {
                    this.$message({ message: res.data.msg || '操作失败', type: 'error' });
                }
            }).catch(() => {
                this.itemsLoading = false;
                this.$message({ message: '操作失败', type: 'error' });
            });
        },

        callFunction(item) {
            if (typeof item.search == 'object') {
                this.filters = item.search
            } else {
                this.filters = {
                    key: item.search,
                }
            }
            this[item.Func].apply(this, item)
        },

        // 导入
        ImportCensus() {
            this.resetEvalImportDialog();
            this.evalImportDialogVisible = true;
        },
        resetEvalImportDialog() {
            this.evalImportFileRaw = null;
            this.evalImportParsing = false;
            this.evalImportUploadKey += 1;
        },
        onEvalImportDialogClosed() {
            if (this.evalImportKeepFileOnClose) {
                this.evalImportKeepFileOnClose = false;
                return;
            }
            this.resetEvalImportDialog();
        },
        backToEvalImportSelect() {
            this.excelShow = false;
            this.evalImportDialogVisible = true;
        },
        onEvalImportFileChange(file) {
            this.evalImportFileRaw = file && file.raw ? file.raw : null;
        },
        onEvalImportFileRemove() {
            this.evalImportFileRaw = null;
        },
        onEvalImportExceed(files) {
            const nextFile = files && files[0];
            if (!nextFile) return;
            this.evalImportUploadKey += 1;
            this.$nextTick(() => { this.evalImportFileRaw = nextFile; });
        },
        downloadEvalImportTemplate() {
            // 项目评分方式：固定分值 / 最大值 / 分数范围；分数范围时须填最低分，项目分值为上限。最后更新：2026-09-11
            const headers = ['父级维度', '评价维度', '评价项目', '项目类型', '项目评分方式', '项目分值', '最低分'];
            const samples = [
                ['', '品德表现', '诚实守信', '表扬', '固定分值', 5, ''],
                ['', '品德表现', '课堂表现', '表扬', '最大值', 10, ''],
                ['习惯行端', '卫生保洁', '积极参与班级卫生保洁', '表扬', '分数范围', 10, 2],
            ];
            const dataSheet = utils.aoa_to_sheet([headers, ...samples]);
            dataSheet['!cols'] = [
                { wch: 14 }, { wch: 14 }, { wch: 28 }, { wch: 10 },
                { wch: 14 }, { wch: 10 }, { wch: 10 },
            ];

            const tipRows = [
                ['评价维度批量导入 — 填写说明'],
                [''],
                ['一、基本规则'],
                ['1. 学校以系统顶部当前所选学校为准，模板中无需填写学校。'],
                ['2. 「评价维度」「评价项目」必填；「父级维度」可选（有二级结构时填写）；名称均不超过500字。'],
                ['3. 「项目类型」填写：表扬 / 待改进（也可写加分 / 减分 / 扣分）。'],
                [''],
                ['二、项目评分方式（三选一）'],
                ['1. 固定分值：点评时固定使用「项目分值」；「最低分」留空。'],
                ['2. 最大值：点评时可在 0～项目分值 之间取值；「最低分」留空。'],
                ['3. 分数范围：点评分须在「最低分」～「项目分值(最高分)」之间；最低分必填，且不能大于项目分值。'],
                [''],
                ['三、示例说明'],
                ['「评价维度导入」工作表中已附 3 行示例，可对照修改或删除后填写真实数据。'],
                ['导入前请删除不需要的示例行，避免误写入系统。'],
            ];
            const tipSheet = utils.aoa_to_sheet(tipRows);
            tipSheet['!cols'] = [{ wch: 88 }];

            const book = utils.book_new();
            utils.book_append_sheet(book, dataSheet, '评价维度导入');
            utils.book_append_sheet(book, tipSheet, '填写说明');
            writeFile(book, '评价维度批量导入模板.xlsx');
        },
        parseEvalImportFile() {
            if (!this.evalImportFileRaw) {
                this.$message.warning('请先选择 Excel 文件');
                return;
            }
            const file = this.evalImportFileRaw;
            if (!/\.(xls|xlsx)$/.test(file.name.toLowerCase())) {
                this.$message.error('上传格式不正确，请上传 xls 或 xlsx 格式');
                return;
            }
            this.evalImportParsing = true;
            const fileReader = new FileReader();
            fileReader.onload = (ev) => {
                try {
                    const workbook = read(ev.target.result, { type: 'binary' });
                    const ws = utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);
                    this.outputs = this.reSetKey(ws);
                    this.importPage = 1;
                    this.evalImportParsing = false;
                    this.evalImportKeepFileOnClose = true;
                    this.evalImportDialogVisible = false;
                    this.excelShow = true;
                } catch (e) {
                    this.evalImportParsing = false;
                    this.$message.error('文件读取失败');
                }
            };
            fileReader.onerror = () => {
                this.evalImportParsing = false;
                this.$message.error('文件读取失败');
            };
            fileReader.readAsBinaryString(file);
        },
        resolveActiveSchoolId() {
            const raw = this.$store.state.activeSchoolId || window.localStorage.getItem('activeSchoolId');
            if (raw === null || raw === undefined || raw === '' || raw === '0') return null;
            return raw;
        },
        showImportResult(resData) {
            this.importResult = (resData && resData.response) || null;
            this.importResultVisible = true;
            const normalized = normalizeImportBatchResponse(resData || {});
            if (!normalized.items.length) {
                const text = normalized.summary || (resData && resData.msg) || '';
                if (text) this.$message.success(text);
            }
        },

        //删除错误行
        removeImport(e) {
            const name = e.row.Item || e.row.Dimension || '该行';
            this.$confirm('确定要删除 ' + name + ' 的信息?').then(() => {
                const realIndex = (this.importPage - 1) * this.importPageSize + e['$index'];
                this.outputs.splice(realIndex, 1);
                if (this.importPage > 1 && this.pagedOutputs.length === 0) {
                    this.importPage = this.importPage - 1;
                }
            });
        },
        SavaImport() {
            const schoolDepartmentId = this.resolveActiveSchoolId();
            if (!schoolDepartmentId) {
                this.$message.warning('请先在顶部选择学校');
                return;
            }
            if (!this.outputs.length) {
                this.$message.warning('没有可导入的数据，请检查导入内容');
                return;
            }
            const loading = this.$loading({ lock: true, text: '导入中', background: 'rgba(0, 0, 0, 0.7)' });
            importEvaluationDimensions({ schoolDepartmentId: schoolDepartmentId, items: this.outputs })
                .then((res) => {
                    loading.close();
                    if (res.data && res.data.success) {
                        this.excelShow = false;
                        this.showImportResult(res.data);
                        this.handleQuery();
                    } else {
                        this.showImportResult(res.data || {});
                        if (!this.importResult) {
                            this.$message.error((res.data && res.data.msg) || '导入失败');
                        }
                    }
                })
                .catch(() => {
                    loading.close();
                    this.$message.error('导入失败');
                });
        },
        reSetKey(ws) {
            const temp = [];
            ws.forEach((item) => {
                const parentDim = item['父级维度'] || item['ParentDimension'] || '';
                const rawScore = item['项目分值'] || item['ScoreValue'];
                let parsedScore = rawScore === undefined || rawScore === '' ? 0 : parseFloat(rawScore);
                parsedScore = isNaN(parsedScore) ? 0 : parsedScore;
                const rawMin = item['最低分'] || item['MinScore'];
                let parsedMin = null;
                if (rawMin !== undefined && rawMin !== null && rawMin !== '') {
                    const n = parseFloat(rawMin);
                    parsedMin = isNaN(n) ? null : n;
                }
                const rawType = String(item['项目类型'] || item['ItemType'] || '').trim();
                // 加分/表扬 → 表扬；扣分/减分/待改进 → 待改进。最后更新：2026-09-11
                let itemType = rawType;
                if (/扣分|减分|待改进|improvement/i.test(rawType)) itemType = '待改进';
                else if (/加分|表扬|praise/i.test(rawType)) itemType = '表扬';

                const rawMode = String(item['项目评分方式'] || item['ScoreMode'] || '').trim();
                let scoreMode = rawMode;
                if (/范围|range/i.test(rawMode)) scoreMode = '分数范围';
                else if (/最大|max/i.test(rawMode)) scoreMode = '最大值';
                else if (/固定|fixed/i.test(rawMode)) scoreMode = '固定分值';

                temp.push({
                    ParentDimension: parentDim,
                    Dimension: item['评价维度'] || item['Dimension'] || '',
                    Item: item['评价项目'] || item['Item'] || '',
                    ItemType: itemType,
                    ScoreMode: scoreMode,
                    ScoreValue: parsedScore,
                    MinScore: parsedMin,
                });
            });
            return temp;
        },
        handleImportCurrentChange(page) {
            this.importPage = page;
        },
        handleImportSizeChange(size) {
            this.importPageSize = size;
            this.importPage = 1;
        },

    },
    mounted() {
        let routers = window.localStorage.router
            ? JSON.parse(window.localStorage.router)
            : [];
        this.buttonList = getButtonList(this.$route.path, routers);
    },
};
</script>

<style scoped>
.muted-dash {
    color: #c0c4cc;
}
.dimension-icon {
    width: 30px;
    height: 30px;
    border-radius: 4px;
    object-fit: cover;
}

.cat-list-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    margin-right: 8px;
    border: 1px solid #e5eaf0;
    border-radius: 8px;
    background: #f8fafc;
    color: #b8c4d1;
    vertical-align: middle;
}

.cat-list-icon img {
    width: 24px;
    height: 24px;
    object-fit: contain;
    cursor: zoom-in;
}

.cat-list-icon--small {
    width: 26px;
    height: 26px;
    margin-right: 6px;
    border-radius: 7px;
}

.cat-list-icon--small img {
    width: 21px;
    height: 21px;
}

.icon-preview-content {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 260px;
    padding: 20px;
    background: #f8fafc;
}

.icon-preview-content img {
    max-width: 240px;
    max-height: 240px;
    object-fit: contain;
}

.pagination-container {
    margin-top: 12px;
    display: flex;
    justify-content: flex-end;
}

/* 覆盖 split-layout.css 全局 el-pagination 的 margin/阴影，避免 dp-right 出现多余滚动 */
.pagination-container ::v-deep .el-pagination {
    display: inline-flex;
    width: auto;
    margin: 0;
    padding: 0;
    background: transparent;
    box-shadow: none;
    float: none;
}

.item-toolbar {
    margin-bottom: 20px;
}

.item-toolbar .el-button {
    margin-right: 10px;
}

.score-value {
    font-weight: 500;
    font-size: 14px;
}

.score-add {
    color: #67c23a;
}

.score-deduct {
    color: #f56c6c;
}

.dialog-footer {
    text-align: right;
    padding-top: 20px;
}

::v-deep .dim-edit-dialog .el-dialog {
    overflow: hidden;
    border-radius: 14px;
    box-shadow: 0 18px 48px rgba(15, 23, 42, .18);
}

::v-deep .dim-edit-dialog .el-dialog__header {
    padding: 20px 24px 16px;
    border-bottom: 1px solid #edf2f7;
    background: linear-gradient(180deg, #f8fbff 0%, #ffffff 100%);
}

::v-deep .dim-edit-dialog .el-dialog__title {
    color: #16324f;
    font-size: 16px;
    font-weight: 700;
}

::v-deep .dim-edit-dialog .el-dialog__body {
    max-height: 72vh;
    padding: 18px 20px 8px;
    overflow-y: auto;
}

::v-deep .dim-edit-dialog .el-dialog__footer {
    padding: 14px 24px 18px;
    border-top: 1px solid #edf2f7;
    background: #ffffff;
}

.dim-edit-form ::v-deep .el-form-item {
    margin-bottom: 15px;
}

.dim-edit-form ::v-deep .el-form-item__label {
    color: #526277;
    font-size: 13px;
    font-weight: 500;
}

.dimension-settings-tabs {
    min-height: 0;
}

.dimension-settings-tabs ::v-deep .el-tabs__header {
    margin: 0 0 20px;
}

.dimension-settings-tabs ::v-deep .el-tabs__nav-wrap::after {
    height: 1px;
    background: #edf0f5;
}

.dimension-settings-tabs ::v-deep .el-tabs__item {
    height: 38px;
    padding: 0 18px;
    color: #64748b;
    font-size: 13px;
}

.dimension-settings-tabs ::v-deep .el-tabs__item.is-active {
    color: #2563eb;
    font-weight: 600;
}

.dimension-settings-tabs ::v-deep .el-tabs__active-bar {
    height: 2px;
    border-radius: 2px;
    background: #2563eb;
}

.dim-section-title {
    position: relative;
    margin: 2px 0 14px;
    padding-left: 10px;
    color: #1f2937;
    font-size: 13px;
    font-weight: 700;
    line-height: 20px;
}

.dim-section-title::before {
    position: absolute;
    top: 3px;
    left: 0;
    width: 3px;
    height: 14px;
    border-radius: 2px;
    background: #3b82f6;
    content: "";
}

.dim-edit-form ::v-deep .el-input__inner,
.dim-edit-form ::v-deep .el-textarea__inner,
.dim-edit-form ::v-deep .el-select .el-input__inner {
    border-color: #dbe5ef;
    border-radius: 6px;
    font-size: 13px;
    transition: border-color .2s, box-shadow .2s;
}

.dim-edit-form ::v-deep .el-input__inner,
.dim-edit-form ::v-deep .el-select .el-input__inner {
    height: 36px;
}

.dim-edit-form ::v-deep .el-input-number {
    line-height: 36px;
}

.dim-edit-form ::v-deep .el-input__inner:focus,
.dim-edit-form ::v-deep .el-textarea__inner:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, .10);
}

.tab-badge {
    margin-left: 8px;
}

.tab-badge :deep(.el-badge__content) {
    background-color: var(--btn-primary, #2563eb);
}

.form-item-hint {
    margin: 6px 0 0;
    color: #909399;
    font-size: 12px;
    line-height: 1.4;
}

.cat-sort {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 22px;
    height: 22px;
    margin-right: 8px;
    padding: 0 6px;
    border-radius: 6px;
    background: #eff6ff;
    color: #2563eb;
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
    vertical-align: middle;
}

.cat-sort--sm {
    min-width: 20px;
    height: 20px;
    margin-right: 6px;
    font-size: 11px;
}

.notice-switch-row {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    min-height: 36px;
    color: #606266;
    font-size: 13px;
}

.notice-switch-group {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 28px;
}

.notice-metrics-item ::v-deep .el-form-item__content {
    line-height: normal;
}

.dim-metrics {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px;
}

.dim-metric {
    display: flex;
    align-items: center;
    gap: 6px;
    height: 36px;
    margin: 0;
    padding: 0 10px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background: #fff;
}

.dim-metric__name,
.dim-metric__unit {
    flex: none;
    color: #909399;
    font-size: 12px;
    font-weight: 400;
}

.dim-metric ::v-deep .el-input-number {
    flex: 1;
    width: auto;
    line-height: 34px;
}

.dim-metric ::v-deep .el-input__inner {
    height: 34px;
    padding: 0 4px;
    border: 0;
    background: transparent;
    line-height: 34px;
    text-align: left;
}

.dim-icons {
    margin-bottom: 15px;
}

/* 标签与 36px 控件行垂直对齐，说明跟在同一内容列内 */
.dim-icons ::v-deep .el-form-item__label {
    height: 36px;
    line-height: 36px;
    padding-top: 0;
}

.dim-icons ::v-deep .el-form-item__content {
    line-height: 36px;
}

.icon-field {
    line-height: normal;
}

.icon-field .form-item-hint {
    margin-top: 6px;
}

.dim-icons__title {
    display: flex;
    align-items: center;
    margin-bottom: 9px;
}

.dim-icons__title i {
    margin-right: 4px;
    color: #f56c6c;
    font-style: normal;
}

.icon-source-group {
    display: flex;
    align-items: center;
    min-height: 32px;
    margin-bottom: 12px;
    padding: 0;
}

.icon-source-group ::v-deep .el-radio {
    color: #526277;
}

.icon-source-group ::v-deep .el-radio.is-checked {
    color: #2563eb;
}

.icon-inherit-preview {
    display: flex;
    align-items: center;
    gap: 10px;
    min-height: 50px;
    margin-bottom: 2px;
    padding: 6px 10px;
    border: 1px solid #e5edf5;
    border-radius: 8px;
    background: #fafcff;
    color: #606266;
    font-size: 13px;
}

.icon-inherit-preview img {
    width: 34px;
    height: 34px;
    object-fit: contain;
}

.icon-upload-button {
    grid-column: 1 / -1;
    justify-self: start;
    color: #2563eb;
    border-color: #bfdbfe;
    background: #eff6ff;
}

.icon-upload-button:hover,
.icon-upload-button:focus {
    color: #1d4ed8;
    border-color: #93c5fd;
    background: #dbeafe;
}

.icon-upload-area {
    text-align: center;
}

.icon-upload-file {
    margin-top: 12px;
    color: #606266;
    font-size: 13px;
}

.icon-upload-file i {
    margin-right: 6px;
    color: #409eff;
}

.icon-select-row {
    display: flex;
    align-items: center;
    gap: 12px;
    line-height: normal;
}

.icon-select-row ::v-deep .el-button {
    height: 36px;
    padding: 0 14px;
    line-height: 34px;
}

.icon-current-preview {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border: 1px solid #dbe5ef;
    border-radius: 6px;
    background: #f8fafc;
}

.icon-current-preview img {
    width: 28px;
    height: 28px;
    object-fit: contain;
}

.icon-current-preview i {
    color: #b8c4d1;
    font-size: 18px;
}

.icon-library-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
}

.icon-library-section {
    padding: 14px;
    border: 1px solid #edf2f7;
    border-radius: 10px;
    background: #fbfdff;
}

.icon-library-section__title {
    margin-bottom: 12px;
    color: #334155;
    font-size: 13px;
    font-weight: 600;
}

.icon-library-section__title span {
    margin-left: 6px;
    color: #94a3b8;
    font-weight: 400;
}

.icon-library-grid {
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    gap: 10px;
    max-height: 300px;
    overflow-y: auto;
}

.icon-library-item {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 0;
    padding: 8px 5px 6px;
    border: 1px solid #e5eaf0;
    border-radius: 9px;
    background: #ffffff;
    cursor: pointer;
    transition: border-color .18s, background .18s, box-shadow .18s;
}

.icon-library-item:hover {
    border-color: #93c5fd;
    background: #f8fbff;
}

.icon-library-item.is-selected {
    border: 2px solid #2563eb;
    background: #eff6ff;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, .10);
}

.icon-library-item img {
    width: 42px;
    height: 42px;
    object-fit: contain;
}

.icon-library-item__name {
    width: 100%;
    margin-top: 5px;
    overflow: hidden;
    color: #64748b;
    font-size: 11px;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.icon-library-item__delete {
    position: absolute;
    top: 4px;
    right: 5px;
    color: #ef4444;
    font-size: 13px;
}

.icon-library-item__delete:hover {
    color: #b91c1c;
}

.icon-library-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 32px 0;
    color: #94a3b8;
    font-size: 13px;
}

.icon-library-empty i {
    font-size: 30px;
}

.icon-upload-panel {
    margin-top: 14px;
    padding: 14px;
    border: 1px dashed #bfdbfe;
    border-radius: 10px;
    background: #f8fbff;
}

.icon-upload-panel__title {
    margin-bottom: 10px;
    color: #334155;
    font-size: 13px;
    font-weight: 600;
}

.dim-icons__grid {
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    gap: 8px;
    max-height: 220px;
    padding: 2px 2px 4px;
    overflow-y: auto;
}

.dim-icons__item {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 62px;
    padding: 7px;
    border: 1px solid transparent;
    border-radius: 8px;
    background: #f7f9fc;
    cursor: pointer;
    transition: border-color .18s, background .18s, box-shadow .18s;
}

.dim-icons__item img {
    display: block;
    width: 44px;
    height: 44px;
    object-fit: contain;
}

.dim-icons__item:hover {
    border-color: #bfdbfe;
    background: #f0f7ff;
}

.dim-icons__item.is-on,
.dim-icons__item.is-on:hover {
    border: 2px solid #2563eb;
    background: #eff6ff;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, .12);
}

@media (max-width: 720px) {
    ::v-deep .dim-edit-dialog {
        width: calc(100% - 24px) !important;
    }

    .dim-icons__grid {
        grid-template-columns: repeat(5, minmax(0, 1fr));
    }
}

/* 可见角色：少量选中时 tag 换行完整展示 */
.role-select-visible ::v-deep .el-select__tags {
    flex-wrap: wrap;
    max-width: 100%;
}

.role-select-visible ::v-deep .el-select__tags > span {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
}

.role-select-visible ::v-deep .el-input__inner {
    height: auto;
    min-height: 40px;
}
</style>
